<template>
  <div class="d-flex">
    <div class="properties-container pr-1">
      <Vuedraggable
        class="properties-draggable"
        :list.sync="invalue"
        @end="draggableEnd"
        :disabled="disabled"
      >
        <el-image
          v-for="(item, index) in listImageUrl"
          :key="index"
          :src="item"
          fit="contain"
        />
      </Vuedraggable>
    </div>
    <el-button type="info" @click="choosePropertiesVisible = true">
      {{ $l('btn_chooseCharacter') || '选择特性' }}
    </el-button>

    <ChooseProperties
      :visible.sync="choosePropertiesVisible"
      @confirm="confirm"
      :chooseKeys="propertiesCodes"
    />
  </div>
</template>

<script>
import ChooseProperties from '../choose-properties'
import Vuedraggable from 'vuedraggable'
export default {
  props: {
    value: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
  },
  components: { ChooseProperties, Vuedraggable },
  data() {
    return { choosePropertiesVisible: false, invalue: [] }
  },
  computed: {
    listImageUrl() {
      if (!this.invalue || !this.invalue.length) return []
      return this.invalue.map((item) => item.imageUrl)
    },
    propertiesCodes() {
      if (!this.invalue || !this.invalue.length) return []
      return this.invalue.map((item) => item.samplePropertiesImageCode)
    },
  },
  watch: {
    value: {
      handler(val) {
        this.invalue = val
      },
      deep: true,
    },
  },
  created() {
    this.invalue = this.value
  },
  methods: {
    confirm(data) {
      if (!data?.length) {
        this.$emit('change', [])
        this.$emit('input', [])
        this.$emit('update:value', [])
        return
      }

      if (!this.invalue || !this.invalue.length) {
        this.$emit('change', data)
        this.$emit('input', data)
        this.$emit('update:value', data)
        return
      }

      const exists = this.invalue.filter(
        (i) =>
          data.findIndex(
            (j) => j.samplePropertiesImageCode === i.samplePropertiesImageCode
          ) >= 0
      )
      const adds = data.filter(
        (i) => !this.propertiesCodes.includes(i.samplePropertiesImageCode)
      )

      const val = exists.concat(adds)
      this.$emit('change', val)
      this.$emit('input', val)
      this.$emit('update:value', val)
    },
    draggableEnd() {
      this.$emit('change', this.invalue)
      this.$emit('input', this.invalue)
      this.$emit('update:value', this.invalue)
    },
  },
}
</script>
<style lang="scss" scoped>
.properties-container {
  flex: 1;
  min-height: 94px;
  .properties-draggable {
    border: 1px solid #ebeef5;
    min-height: 100%;
    .el-image {
      --w: calc(100% / 8 - 10px);
      width: var(--w);
      aspect-ratio: 1;
      margin: 0 5px 0 5px;
      border: 1px solid #ebeef5;
      padding: 2px;
      border-radius: 2px;
      position: relative;
    }
    .el-image:nth-child(-n + 8) {
      margin-top: 5px !important;
    }
    .el-image:nth-child(-n + 6):after {
      content: '';
      background-image: url('/image/static/img/tag.svg');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: center center;
      position: absolute;
      top: 0;
      right: 0;
      width: 20px;
      height: 20px;
    }
  }
}
.is-error .properties-draggable {
  border-color: #f56c6c;
}
</style>
